/**
 * It defines the context state for the HomeModule and provides convenient methods to mutate it.
 *
 * @author jennifer.ajoy
 */

export class HomeContextState {
  constructor(state: Partial<HomeContextState> = {}) {
    Object.assign(this, state);
  }
}